import DataFileReader from "../../../../../containers/student-data-upload/FileReader";
import React from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { Assessment } from "../../../../../store/onboarding/types";
import { ApplicationState } from "../../../../../store";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";

library.add(faFile);

type PropsFromState = {
  assessments: Array<Assessment>;
};

type OwnProps = {
  originalFileName: string;
  rawData: Array<any>;
  multiRawDataCount: number;
  isDetectAssessmentLoading: boolean;
};

type Props = OwnProps & PropsFromState;

const UploadInfo = (props: Props) => {
  return (
    <div className="text-center">
      <h2 className="font-weight-semibold mb-2">Great, you uploaded:</h2>
      <div>
        <FontAwesomeIcon icon="file" />
        <h4 className="font-weight-bold d-inline blackText mb-2">
          &nbsp;{props.originalFileName}
        </h4>
        <h4 className="my-2">
          It has {props.isDetectAssessmentLoading ? <Spinner animation="border" size="sm" /> : props.multiRawDataCount > 0 ? props.multiRawDataCount : props.rawData.length} rows. &nbsp;
          <label className="clickableLabel">
            Click here to pick a different file.
            <DataFileReader />
          </label>
        </h4>
      </div>
    </div>
  );
};

const mapStateToProps = ({ onboarding }: ApplicationState): PropsFromState => {
  return {
    assessments: onboarding.assessments,
  };
};

export default connect(mapStateToProps)(UploadInfo);
